import HttpClient from "../helpers/HttpClient"
import CalendarEvent, { CalendarEventDto } from "./CalendarEvent"

class CalendarEventService {
    static httpClient: HttpClient<CalendarEvent,
        CalendarEventDto> = new HttpClient<CalendarEvent, CalendarEventDto>(CalendarEvent)

    static async get(id: string) {
        return this.httpClient.get("/calendar-events/" + id)
    }

    static async create(calendarId: string, payload: object) {
        return this.httpClient.post(`/calendars/${calendarId}/calendar-events`, payload)
    }

    static async update(id: string, payload: object) {
        return this.httpClient.patch("/calendar-events/" + id, payload)
    }

    static async delete(id: string) {
        return this.httpClient.delete("/calendar-events/" + id)
    }

}

export default CalendarEventService


// WEBPACK FOOTER //
// ./src/state/calendar-event/CalendarEventService.ts